import { CountryDto } from '../dtos/system-configuration.dto';

type StringKeys<T> = {
    [K in keyof T]: T[K] extends string ? K : never;
}[keyof T];

export const getCountriesMapByStringKey = (countryDtoMap: Record<string, CountryDto[]> | undefined, keyField: StringKeys<CountryDto>): {
    [key: string]: CountryDto } => {
    return Object.values(countryDtoMap || [])
        .flat()
        .reduce((acc: { [key: string]: CountryDto }, cur: CountryDto) => {
            acc[cur[keyField]] = cur;
            return acc;
        }, {});
};

export const searchFieldsToString = (countryDtoMap: Record<string, CountryDto[]> | undefined, fieldsArray: (keyof any)[] | undefined, item: any): string => {
    if (fieldsArray?.length) {
        return fieldsArray.map((key) =>
            searchNestedFieldsToString(countryDtoMap, item[key.toString()])).filter(Boolean).join(',').toUpperCase();
    }
    return searchNestedFieldsToString(countryDtoMap, item);
};

const getObjectValues = (item: any, countryDtoMap: Record<string, CountryDto[]> | undefined, result: string[], stack: any[]) => {
    Object.entries(item).forEach(([key, value]) => {
        if (!value) return;

        if (key === 'regions' && Array.isArray(value) && value.length) {
            const countryNameByCode = getCountriesMapByStringKey(countryDtoMap, 'countryCode');
            result.push(...value.map((country: string) => countryNameByCode[country]?.countryName || ''));
        } else if (key === 'addresses' && Array.isArray(value) && value.length) {
            result.push(...value.map((adr: string) => adr !== 'SANE_DoNotDelete' ? adr : ''));
        } else {
            stack.push(value);
        }
    });
};

const searchNestedFieldsToString = (countryDtoMap: Record<string, CountryDto[]> | undefined, item: any):  string => {
    if (item === null) return '';
    const stack = [item];
    const result: string[] = [];

    while (stack.length > 0) {
        const item = stack.pop();
        
        if (typeof item !== 'object' && typeof item !== 'boolean') {
            result.push(item);
            continue;
        }
        getObjectValues(item, countryDtoMap, result, stack);
    }
    return result.filter(Boolean).join(',').toUpperCase();
};